import { INSTRUCTION, ZOG, GA } from '../../constants/shared/CommonConstants';
import { HELP_PANEL_TAB } from '../../constants/shared/PMConstants';

const { STUDENTS, ALL_ACTIVITIES } = INSTRUCTION;

export const getInstructionHelpParam = instructionTab => {
    switch (instructionTab) {
        case STUDENTS: {
            return 'I_S';
        }
        case ALL_ACTIVITIES: {
            return 'I_AA';
        }
        default: {
            return 'I_G';
        }
    }
};

export const getProgressHelpParam = progressTab => {
    switch (progressTab) {
        case ZOG.GOAL_SETTINGS: {
            return 'P_ZOG';
        }
        case GA.GROWTH_ANALYSIS: {
            return 'P_GO';
        }
        default: {
            return HELP_PANEL_TAB;
        }
    }
};

export const isPageAccessibleForHelpType = (pageMapper, pathname) =>
    Object.keys(pageMapper).includes(pathname);
